export class VerificationEntity {
    content;
  
    constructor(content = "") {
      this.content = content;
    }
  }
  